import { getCustomQueries } from '@/helpers/queryHelper';
import {
  GET_SUBJECTS,
  GET_SUBJECTS_SUCCEEDED,
  GET_SUBJECTS_FAILED,
  GET_SUBJECT_BY_SLUG,
  GET_SUBJECT_BY_SLUG_SUCCEEDED,
  GET_SUBJECT_BY_SLUG_FAILED,
  ADD_SUBJECT,
  ADD_SUBJECT_SUCCEEDED,
  ADD_SUBJECT_FAILED,
  DELETE_SUBJECT,
  DELETE_SUBJECT_SUCCEEDED,
  DELETE_SUBJECT_FAILED,
  EDIT_SUBJECT,
  EDIT_SUBJECT_SUCCEEDED,
  EDIT_SUBJECT_FAILED,
  SET_SUBJECT_DATA,
  SET_SUBJECT_EDIT_DATA,
  SET_SUBJECT_ERROR_DATA,
  COPY_SUBJECT_CONTENT,
  COPY_SUBJECT_CONTENT_SUCCEEDED,
  COPY_SUBJECT_CONTENT_FAILED,
  GET_SUBJECTS_BY_PAGE,
  GET_SUBJECTS_BY_PAGE_SUCCEEDED,
  GET_SUBJECTS_BY_PAGE_FAILED,
} from './index';

export const getSubjects = (data = {}, queries = {}) => {
  const query = getCustomQueries(queries);
  return {
    type: GET_SUBJECTS,
    payload: {
      url: `course/subject/?${query}&course=${data}`,
      onSuccess: GET_SUBJECTS_SUCCEEDED,
      onFailure: GET_SUBJECTS_FAILED,
    },
  };
};
export const getSubjectBySlug = (data = {}) => {
  return {
    type: GET_SUBJECT_BY_SLUG,
    payload: {
      url: `course/subject/${data}`,
      onSuccess: GET_SUBJECT_BY_SLUG_SUCCEEDED,
      onFailure: GET_SUBJECT_BY_SLUG_FAILED,
    },
  };
};
export const getSubjectsByPage = (data = {}, queries = {}) => {
  const query = getCustomQueries(queries);
  return {
    type: GET_SUBJECTS_BY_PAGE,
    payload: {
      url: `course/subject/?${query}&course=${data}`,
      onSuccess: GET_SUBJECTS_BY_PAGE_SUCCEEDED,
      onFailure: GET_SUBJECTS_BY_PAGE_FAILED,
    },
  };
};

export const addSubject = (data = {}) => {
  return {
    type: ADD_SUBJECT,
    payload: {
      data,
      url: 'course/subject/',
      onSuccess: ADD_SUBJECT_SUCCEEDED,
      onFailure: ADD_SUBJECT_FAILED,
    },
  };
};

export const editSubject = (data = {}, slug = {}) => {
  return {
    type: EDIT_SUBJECT,
    payload: {
      data,
      url: `course/subject/${slug}/`,
      onSuccess: EDIT_SUBJECT_SUCCEEDED,
      onFailure: EDIT_SUBJECT_FAILED,
    },
  };
};

export const deleteSubject = (data = {}) => {
  return {
    type: DELETE_SUBJECT,
    payload: {
      url: `course/subject/${data}`,
      onSuccess: DELETE_SUBJECT_SUCCEEDED,
      onFailure: DELETE_SUBJECT_FAILED,
    },
  };
};

export const copySubjectContent = (data = {}, slug = {}) => {
  return {
    type: COPY_SUBJECT_CONTENT,
    payload: {
      data,
      url: `copy-subject/${slug}/`,
      onSuccess: COPY_SUBJECT_CONTENT_SUCCEEDED,
      onFailure: COPY_SUBJECT_CONTENT_FAILED,
    },
  };
};

export const setSubjectData = (data = {}) => {
  return {
    type: SET_SUBJECT_DATA,
    payload: {
      data,
    },
  };
};
export const setSubjectEditData = (data = {}) => {
  return {
    type: SET_SUBJECT_EDIT_DATA,
    payload: {
      data,
    },
  };
};

export const setSubjectErrorData = (data = {}) => {
  return {
    type: SET_SUBJECT_ERROR_DATA,
    payload: {
      data,
    },
  };
};
